if (!customElements.get('sss-statue-slider')) {
  customElements.define('sss-statue-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const list = this.querySelector('ul');
      const buttons = [...this.querySelectorAll('button[data-direction]')];
      const update = () => {
        buttons[0].disabled = list.scrollLeft <= 2;
        buttons[1].disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
        this.querySelector('.sss-statue-slider__controls').hidden = list.scrollWidth <= list.clientWidth + 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = list.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0) : list.clientWidth;
        list.scrollBy({left: Number(button.dataset.direction) * step});
      }));
      list.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(list);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
  });
}
